import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-depreciation-register-controller',
  templateUrl: './depreciation-register-controller.component.html',
  styleUrls: ['./depreciation-register-controller.component.css']
})
export class DepreciationRegisterControllerComponent implements OnInit {

  depreciationHistoryList: any = [];
  compatibleDepreciationList: any = [];
  totalDepreciationHistoryList: any = [];
  notCompatibleDepreciationList: any = [];

  compatibleDepreciationCount: any = 0
  notCompatibleDepreciationCount: any = 0
  totalDepreciationCount: any = 0

  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  isLoading: boolean = false;
  id: any;

  addForm!: FormGroup;
  updateForm!: FormGroup;
  formSubmit: boolean = false;
  isEdit: boolean = false;

  cid: any;
  objectInfoList: any = [];
  minYear: number = 2000;
  maxYear: number = 3000;

  singleDepreciationdeHistoryData: any = [];
  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  };

  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";
  isCompatible: any = true

  constructor(
    private generic_service: GenericService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/');
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1]);
    this.actionControls = action;

    this.cid = sessionStorage.getItem('cid');

    this.addForm = this.fb.group({
      assetName: ['', Validators.required],
      assetGivenName: ['', Validators.required],
      year: ['', [Validators.required, Validators.min(this.minYear), Validators.max(this.maxYear)]],
      depAmount: ['', Validators.required],
      accumulatedDepValue: ['', Validators.required],
      purchasedAmt: ['', Validators.required],
      currentAmt: ['', Validators.required],
      description: [''],
      assetId: ['', Validators.required],
      assetCategory: ['', Validators.required],
      depreciationMethod: ['', Validators.required],
      putToUseDate: ['', Validators.required],
      lastRunDate: ['', Validators.required],
      depreciatedCost: ['', Validators.required],
      originalCost: ['', Validators.required],
      reason: ['', Validators.required],
      depreciationCompatible: ['', Validators.required],
    });

    this.updateForm = this.fb.group({
      assetName: ['', Validators.required],
      assetGivenName: ['', Validators.required],
      year: ['', [Validators.required, Validators.min(this.minYear), Validators.max(this.maxYear)]],
      depAmount: ['', Validators.required],
      accumulatedDepValue: ['', Validators.required],
      purchasedAmt: ['', Validators.required],
      currentAmt: ['', Validators.required],
      description: [''],
      assetId: ['', Validators.required],
      assetCategory: ['', Validators.required],
      depreciationMethod: ['', Validators.required],
      putToUseDate: ['', Validators.required],
      lastRunDate: ['', Validators.required],
      depreciatedCost: ['', Validators.required],
      originalCost: ['', Validators.required],
      reason: ['', Validators.required],
      depreciationCompatible: ['', Validators.required],
    });

    this.getAllDepreciationHistory();
    this.getAllObjectInfo();
    this.getAllCompatibleDepreciationHistorys(true)
  }


addDepreciationRegister() {
  this.formSubmit = true;

  const selectedAsset = this.objectInfoList.find(
    (list: any) => list.givenName === this.addForm.get('assetName')?.value
  );

  if (selectedAsset) {
    this.addForm.patchValue({
      assetGivenName: selectedAsset.name,
      assetId: selectedAsset.objectInfoId,
    });
  }

  if (!this.addForm.valid) {
    this.toastr.error("Please fill in all required fields");
    return;
  }

  const formValues = this.addForm.value;

  const body = {
    version: 0,
    isActive: true,
    cid: Number(this.cid),
    assetName: formValues.assetName,
    assetGivenName: formValues.assetGivenName,
    year: formValues.year,
    depAmount: formValues.depAmount,
    accumulatedDepValue: formValues.accumulatedDepValue,
    purchasedAmt: formValues.purchasedAmt,
    currentAmt: formValues.currentAmt,
    description: formValues.description,
    assetId: formValues.assetId,
    assetCategory: formValues.assetCategory,
    depreciationMethod: formValues.depreciationMethod,
    putToUseDate: formValues.putToUseDate,
    lastRunDate: formValues.lastRunDate,
    depreciatedCost: formValues.depreciatedCost,
    originalCost: formValues.originalCost,
    reason: formValues.reason,
    depreciationCompatible: formValues.depreciationCompatible,
  };

  this.generic_service.addDepreciationRegister(body).subscribe(
    (response: any) => {
      this.formSubmit = false;
      this.addForm.reset();
      this.cancelModel();
      this.getAllDepreciationHistory();
      this.toastr.success(response.message);
    },
    (err: any) => {
      console.log(err);
      this.toastr.error(err.error.errors[0]?.description || "An error occurred.");
    }
  );
}


updateDepreciationRegister() {
  this.formSubmit = true;

  const selectedAsset = this.objectInfoList.find(
    (list: any) => list.givenName === this.updateForm.get('assetName')?.value
  );

  if (selectedAsset) {
    this.updateForm.patchValue({
      assetGivenName: selectedAsset.name,
      assetId: selectedAsset.objectInfoId,
    });
  }

  if (!this.updateForm.valid) {
    this.toastr.error("Please fill in all required fields");
    return;
  }

  const formValues = this.updateForm.value;

  const body = {
    version: 0,
    isActive: true,
    id: this.singleDepreciationdeHistoryData[0].id,
    depreciationRegisterId: this.singleDepreciationdeHistoryData[0].depreciationRegisterId,
    cid: Number(this.cid),
    assetName: formValues.assetName,
    assetGivenName: formValues.assetGivenName,
    year: formValues.year,
    depAmount: formValues.depAmount,
    accumulatedDepValue: formValues.accumulatedDepValue,
    purchasedAmt: formValues.purchasedAmt,
    currentAmt: formValues.currentAmt,
    description: formValues.description,
    assetId: formValues.assetId,
    assetCategory: formValues.assetCategory,
    depreciationMethod: formValues.depreciationMethod,
    putToUseDate: formValues.putToUseDate,
    lastRunDate: formValues.lastRunDate,
    depreciatedCost: formValues.depreciatedCost,
    originalCost: formValues.originalCost,
    reason: formValues.reason,
    depreciationCompatible: formValues.depreciationCompatible,
  };

  this.generic_service.updateDepreciationRegister(body).subscribe(
    (response: any) => {
      this.isEdit = false;
      this.formSubmit = false;
      this.updateForm.reset();
      this.cancelModel();
      this.getAllDepreciationHistory();
      this.toastr.success(response.message);
    },
    (err: any) => {
      console.log(err);
      this.toastr.error(err.error.errors[0]?.description || "Update failed.");
    }
  );
}


  getAllObjectInfo() {
    this.generic_service.getAllObjectInfo().subscribe(
      (response: any) => {
        this.objectInfoList = response.response;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getDepreciation(){

  }

  getAllCompatibleDepreciationHistorys(isCompatible: any){
    this.isLoading = true;
    this.generic_service.getAllCompatibleDepreciationHistorys(isCompatible).subscribe(
      (res: any) => {
        console.log(res)

        this.depreciationHistoryList = res.response;

        this.totalRecords = res.response.length;
        this.isLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  getAllDepreciationHistory() {
    this.generic_service.getAllDepreciationHistory().subscribe(
      (res: any) => {
        console.log(res)
        this.notCompatibleDepreciationList = []
        this.compatibleDepreciationList = []
        this.notCompatibleDepreciationCount = 0
        this.compatibleDepreciationCount = 0
        this.totalDepreciationCount = 0

        this.totalDepreciationHistoryList = res.response;
        for(let list of this.totalDepreciationHistoryList){
          if(list.compatible){
            this.compatibleDepreciationList.push(list)
          }else{
            this.notCompatibleDepreciationList.push(list)
          }
        }

        this.notCompatibleDepreciationCount = this.notCompatibleDepreciationList.length
        this.compatibleDepreciationCount = this.compatibleDepreciationList.length
        this.totalDepreciationCount = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getDepreciationHistoryById(depreciationHistoryId: any) {
    this.generic_service.getDepreciationHistoryById(depreciationHistoryId).subscribe(
      (response: any) => {
        this.singleDepreciationdeHistoryData = [];
        this.singleDepreciationdeHistoryData = [response.response];
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  cancelModel() {
    document.getElementById("closeModalAdd")?.click();
    document.getElementById("closeModalUpdate")?.click();
    document.getElementById("closeModalDelete")?.click();
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id;
    this.recordId = list.depreciationRegisterId;
    this.recordName = list.assetName;
  }

  deleteDepreciationRegister() {
    this.generic_service.deleteDepreciationRegister(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllDepreciationHistory();
        this.cancelModel();
      },
      (err: any) => {
        this.toastr.error(err.errors[0]?.description || "Delete failed.");
      }
    );
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllDepreciationHistory();
  }

  getAllAssetDepreciationMethodByWildSearch() {
    if (!this.searchFilter) {
      return;
    }

    this.generic_service.getAllAssetDepreciationMethodByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (!res.response || res.response.length === 0) {
          this.depreciationHistoryList = [];
          this.totalRecords = 0;
          return;
        }

        this.depreciationHistoryList = res.response;
        this.totalRecords = res.response.length;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  onTableDataChange(event: any) { 
    this.pageNumber = event.page+1; 
  }

  clearData(){ 
    this.recordId = "";
    this.recordName = "";
  }


}
